import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: auto;
  padding-bottom: 1rem;
  background: ${({ theme }) => theme.colors.white};
  padding-left: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 1.5rem;
  }
`;

export const SearchAndActionsBlock = styled.div`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;

  & > .actions {
    width: 100%;
    margin-top: 1.5rem;
    display: flex;
    justify-content: flex-start;

    & > button:first-child {
      margin-right: 0.5rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: unset;

    & > .select-container {
      margin-right: 1.5rem;
    }
  }
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  & > header {
    width: 4.125rem;
    height: 2rem;
    left: 1.5rem;
    top: 0px;
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.grayDark3};

    margin-top: 0.5rem;
    margin-bottom: 1rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-bottom: unset;
    }
  }

  & > div.inputs-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;

    & > div {
      display: flex;
      align-items: center;
      flex-direction: column;
      bottom: 0.8rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
      }

      & > .hefesto-button--secondary {
        width: 10.75rem;
        height: 3.125rem;
        justify-content: center;
        margin-top: 1.5rem;
        margin-left: 1.5rem;
        align-self: end;
      }
    }
  }
`;

export const OrderFilterBlock = styled.div`
  display: flex;

  & > div + div {
    margin-left: 1.5rem;
  }

  & > .hefesto-input-wrapper {
    align-self: end;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    & > .hefesto-input-wrapper {
      margin-left: 0;
      margin-top: 1rem;
    }
  }
`;
